// extracted by mini-css-extract-plugin
export default {"Signal":"TunnelSignal_Signal__JvrNS","SignalContainer":"TunnelSignal_SignalContainer__5pDwr"};